module.exports = __webpack_public_path__ + "static/media/trocar-senha.2a9c3dca.svg";